import { useRef, useState, useEffect } from "react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Slide, ToastContainer, toast } from "react-toastify";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Title } from "../../themes/Default/components/Title";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { Documents as DocumentsWrapper } from "../../themes/Default/components/Documents";
import { Item } from "../../themes/Default/components/Documents/components/Item";
import { Form } from "../../themes/Default/components/Form";
import { Row } from "../../themes/Default/components/Form/components/Row";
import { Field } from "../../themes/Default/components/Form/components/Row/components/Field";
import { studentsManagement } from "../../hooks/api/StudentsManagement";
import { useUserToken } from "../../hooks/core/UserToken";
import { userManagement } from "../../hooks/api/UserManagement";

const StudentDocuments = () => {
    const formRef = useRef(null);
    const { t } = useTranslation("common");
    const [documents, setDocuments] = useState([]);
    const { useListDocumentsMutation, useDownloadDocumentMutation } = studentsManagement;
    const { useGetStudentOrEmployeeIdMutation } = userManagement;
    const [getId] = useGetStudentOrEmployeeIdMutation();
    const [listDocuments] = useListDocumentsMutation();
    const [downloadDocument] = useDownloadDocumentMutation();
    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    const [id, setId] = useState();

    const onDocumentDownload = async (event, documentId) => {
        event.preventDefault();
        const blob = await downloadDocument({ studentId: id, documentId }).unwrap();

        const docToDownload = documents.find((doc) => doc.id === documentId);
        let fileName = docToDownload?.fileName ?? "dokument";
        if (docToDownload?.extension) {
            fileName += '.' + docToDownload.extension;
        }

        const urlBlob = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(urlBlob);
    };

    useEffect(() => {
        getId({id: decodedToken.id}).then((result) => {
            setId(result?.data?.studentId);

            const studentId = result?.data?.studentId;
            listDocuments(studentId).then((result) => {
                const documents = result?.data?.records;
                setDocuments(documents);
            });
        });
    }, []);

    const truncateWithTooltip = (text, maxLength = 35) => {
        if (!text) return "";
        const shouldTruncate = text.length > maxLength;
        const truncated = shouldTruncate ? text.slice(0, maxLength) + "..." : text;

        return <span title={shouldTruncate ? text : ""}>{truncated}</span>;
    };

    return (
        <DefaultLayout>
            
            <TopNavigation>
            </TopNavigation>
            <Main>
                <Title>{t("documents")}</Title>
                <Breadcrumps>
                    <Link title={t("documents")} icon="fa-light fa-file"/>
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        document: null,
                    }}
                >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <DocumentsWrapper>
                                        {documents?.length > 0 &&
                                            documents?.map((document, index) => {
                                                return (
                                                    <Item
                                                        id={document.id}
                                                        key={index}
                                                        name={truncateWithTooltip(document.fileName)}
                                                        type={document.mimeType}
                                                        onDownload={(event) => onDocumentDownload(event, document.id)}
                                                    />
                                                );
                                            })}
                                    </DocumentsWrapper>
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default StudentDocuments;
